import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FormFieldList, SfUtils, SmartFormComponent } from 'ngx-smart-form';
import { SharedModule } from 'src/app/_shared/shared.module';
import { PraticaProgressService } from '../../_core/services/pratica-progress.service';

@Component({
  standalone: true,
  imports: [SharedModule],
  selector: 'app-kyc',
  templateUrl: './kyc.component.html',
  styleUrls: ['./kyc.component.scss'],

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KycComponent {
  @ViewChildren(SmartFormComponent)
  smartFormComponentList?: QueryList<SmartFormComponent>;
  @Input() set kycSections(
    sections: { description: string; fields: FormFieldList }[]
  ) {
    if (sections && sections.length > 0) {
      this._kycSections = sections;
      this.cdr.detectChanges();
      if (this.praticaProgressService.isFrozenOrConfermata) {
        this.smartFormComponentList?.forEach((c) => c.form.disable());
      }
      SfUtils.fieldsWithDependenciesValueChanges(
        this.smartFormComponentList?.toArray() || [],
        'SI'
      ).subscribe();
    }
  }

  private _kycSections: { description: string; fields: FormFieldList }[] = [];

  get kycSections() {
    return this._kycSections;
  }

  get kycValue() {
    if (this.smartFormComponentList) {
      let aggregatedValue = SfUtils.aggregateFormsValues(
        this.smartFormComponentList.toArray()
      );
      return aggregatedValue;
    } else {
      return {};
    }
  }

  constructor(
    private cdr: ChangeDetectorRef,
    private praticaProgressService: PraticaProgressService
  ) {}
}
